// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__wRaqD","form":"Contact_form__AZ67e"};